/**
 * Legacy /chat routes — decommissioned.
 * The AI Assistant is now accessible via the CommunicationHub panel (right sidebar).
 * All /chat/* URLs redirect to home so existing bookmarks don't 404.
 */
import React from 'react';
import {Navigate} from 'react-router';

export const routesChat = [
    {path: '/chat',    element: <Navigate to="/" replace/>},
    {path: '/chat/*',  element: <Navigate to="/" replace/>},
];
